import React from 'react';
import PropTypes from 'prop-types';

const TransformationModels = ({ models }) => {
  return (
    <section className="py-8 md:py-12 lg:py-16">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        {/* Section Header */}
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-bold mb-4 md:mb-6">
            <span className="">Our Digital </span>
            <span className="secondary-text">Transformation Models</span>
          </h2>
          <p className=" max-w-4xl mx-auto">
            Two intelligent frameworks—AMI and AiDA—designed to help organizations adapt, accelerate, and scale through AI-driven transformation.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10 lg:gap-12 max-w-3xl mx-auto">
          {models.map((model, index) => (
            <div
              key={index}
              className="group relative rounded-xl overflow-hidden shadow-2xl h-96 md:h-[320px] cursor-pointer transition-all duration-500 hover:shadow-3xl"
            >
              {/* Background Image */}
              <div className="absolute inset-0">
                <img
                  src={model.image}
                  alt={model.title}
                  className="w-full h-full object-cover"
                />
                {/* Dark Overlay - Fades out on hover */}
                <div className="absolute inset-0 primary-bg opacity-70 group-hover:opacity-0 transition-opacity duration-500"></div>
              </div>

              {/* Default State - Title & Description (visible by default, hidden on hover) */}
              <div className="absolute inset-0 flex flex-col items-center justify-center p-8 md:p-10 text-white transition-opacity duration-500 group-hover:opacity-0">
                <h3 className="text-white  mb-3 md:mb-4 text-center relative inline-block mx-auto">
                  {model.title}
                  {/* <span className="absolute bottom-0 left-1/2 right-0 h-0.5 bg-white" /> */}
                </h3>
                <p className="text-white    leading-relaxed text-center max-w-md">
                  {model.description}
                </p>
              </div>

              {/* Hover State - Button Only (hidden by default, visible on hover) */}
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <button
                  onClick={() => window.location.href = model.link}
                  className="primary-bg text-white px-6 py-3 rounded-md  font-semibold hover:opacity-90 transition-all duration-300 transform group-hover:scale-105"
                >
                  {model.buttonText}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

TransformationModels.propTypes = {
  models: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      buttonText: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default TransformationModels;